import { useContext } from "react"
import { Modal } from "react-bootstrap"
import { MensajeContActualizacion } from "../Context/LoadingContext"

export function Loading()
{
    const {Loadings}=useContext(MensajeContActualizacion)
    return (
    
    <Modal show={Loadings} style={{top:"35%",border:"1px solid transparent"}}>
        
            <div className="spinner-box">
                            <div className="loading-icon">
                            </div>
                            <span>Loading...</span>
                            </div>
        
     
    </Modal>
   
    
    )
}